import React, { useMemo, useState } from 'react';
import cn from 'clsx';
import { catalogList } from './service-accordion-styles';

type ServiceAccordionProps = {
  children: React.ReactNode;
  className?: string;
};

export const ServiceAccordion: React.FC<ServiceAccordionProps> = ({ children, className }) => {
  const [servicePanelState, setServicePanelState] = useState<Record<string, boolean>>({});

  const elements = useMemo(() => React.Children.toArray(children), [children]);

  const handlePanelClick = (onClick?: (panelName: string, isOpen: boolean) => void) => (
    panelName: string,
    isOpen: boolean
  ) => {
    const prevCondition = servicePanelState[panelName];
    setServicePanelState({
      ...servicePanelState,
      [panelName]: !prevCondition,
    });

    if (onClick) onClick(panelName, isOpen);
  };

  return (
    <div className={cn(catalogList, className)}>
      {elements.map(element => (
        <>
          {React.isValidElement(element)
            ? React.cloneElement(element, {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                isOpen: servicePanelState[element.props.name],
                onClick: handlePanelClick(element.props.onClick),
                className: cn(element.props.className),
              })
            : element}
        </>
      ))}
    </div>
  );
};
